import React from 'react';

const ComingSoon = () => {
  return (
    <div className="flex flex-col items-center justify-center h-[calc(100vh-150px)] bg-white font-sans">
      <div className="text-center max-w-md mx-auto px-4">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#AEF468]/10 border border-[#AEF468]/30 mb-6">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#AEF468] opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-[#AEF468]"></span>
          </span>
          <span className="text-[11px] font-bold uppercase tracking-wider text-slate-700">
            Development Phase
          </span>
        </div>

        <h1 className="text-5xl font-extrabold text-slate-900 tracking-tight mb-4">
          Coming Soon
        </h1>
        
        <p className="text-slate-500 text-base leading-relaxed mb-10">
          This feature is currently being developed to enhance your data management experience. 
          Stay tuned for updates.
        </p>

        <button 
          onClick={() => window.history.back()}
          className="px-8 py-3 bg-[#AEF468] text-black font-bold text-sm rounded-lg hover:bg-[#9de356] transition-all shadow-sm hover:shadow-md active:scale-95"
        >
          Go Back
        </button>
      </div>

      <div className="absolute bottom-12 text-slate-200 font-bold text-6xl tracking-tighter select-none opacity-50">
        Datara <span className="text-[#AEF468]">2026</span>
      </div>
    </div>
  );
};

export default ComingSoon;